import React from "react";
import Button from "./Button";
import IcLocation from "../../images/ic-location.svg";
import IcMoney from "../../images/ic-money.svg";
import RateStar from "./RateStar";

const CardDoctor = ({ data }) => {
  return (
    <div className="bg-white shadow-lg border overflow-hidden rounded mr-3">
      <img src={data.image} className="w-full h-auto" />
      <div className="px-4 my-3">
        <div className="flex items-center gap-2">
          <p className="font-semibold text-lg">{data.name}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 text-[#16A085]"
          >
            <path
              fillRule="evenodd"
              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="text-[#AEB5BE] my-2 flex flex-col gap-2 text-xs text-start">
          <p className="h-8">{data.special}</p>
          <div className="flex items-center gap-1 my-0.5">
            <div className="flex items-center">
            <RateStar rate={data.rate} />
            </div>
            ({data.review})
          </div>
          <div className="flex items-center gap-2">
            <img src={IcLocation} className="w-4 h-4" />

            {data.location}
          </div>
          <div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-4 h-4"
            >
              <path
                fillRule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
                clipRule="evenodd"
              />
            </svg>
            Available on {data.available}
          </div>
          <div className="flex items-center gap-2">
            <img src={IcMoney} className="w-4 h-4" />

            {data.price}
          </div>
        </div>

        <div className="flex justify-between place-content-center mt-4 gap-2">
          <Button
            title="View Profile"
            btnOutline
            className="w-full block text-center text-xs"
          />
          <Button
            title="Book Now"
            className="w-full block text-center text-xs"
          />
        </div>
      </div>
    </div>
  );
};

export default CardDoctor;
